import gql from 'graphql-tag'

export const LIST = gql`
  query contract($filter: ContractFilter, $sort: SortDirection, $offset: Int, $limit: Int) {
    contract(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
      data {
        id title status_code status_name company_id company_name user_id tender_id counteragent_company_id counteragent_company_name counteragent_user_id number delivery_address has_real_contract subsidiary_id auto_archive need_agreement start_at close_at direction archive_at
      }
      total_count
    }
  }
`

export const CREATE = gql`
  mutation create_contract($tender_id: Int, $counteragent_id: Int) {
    create_contract(tender_id: $tender_id, counteragent_id: $counteragent_id) {
      id title status_code company_id tender_id counteragent_company_id counteragent_user_id number
      delivery_address has_real_contract subsidiary_id auto_archive need_agreement start_at close_at archive_at
    }
  }
`

export const STATE = gql`
  query contract_state($id: Int!) {
    contract_state(id: $id) {
      type : __typename
      ... on IntegerField { spec { title name editable reference required causer } value possible_values errors }
      ... on StringField { spec { title name editable reference required causer } value possible_values errors }
      ... on DatetimeField { spec { title name editable reference required causer } value possible_values errors }
      ... on BooleanField { spec { title name editable reference causer } value possible_values errors }
      ... on FloatField { spec { title name editable reference required causer } value possible_values errors }
      ... on DecimalField { spec { title name editable reference required causer } value possible_values errors }
    }
  }
`

export const UPDATE_STATE = gql`
  mutation update_contract_state($id: Int!, $field: Json!) {
    update_contract_state(id: $id, field: $field) {
      type : __typename
      ... on IntegerField { spec { title name editable reference required causer } value possible_values errors }
      ... on StringField { spec { title name editable reference required causer } value possible_values errors }
      ... on DatetimeField { spec { title name editable reference required causer } value possible_values errors }
      ... on BooleanField { spec { title name editable reference required causer } value possible_values errors }
      ... on FloatField { spec { title name editable reference required causer } value possible_values errors }
      ... on DecimalField { spec { title name editable reference required causer } value possible_values errors }
    }
  }
`

export const REFERENCE = gql`
  query reference($id: Int!, $entity: String!, $reference: String!) {
    reference(id: $id, entity: $entity, reference: $reference) {
      type : __typename
      ... on IntegerField { spec {  title name editable reference required causer } value possible_values errors }
      ... on StringField { spec { title name editable reference required causer } value possible_values errors }
      ... on DatetimeField { spec { title name editable reference required causer } value possible_values errors }
      ... on BooleanField { spec { title name editable reference required causer } value possible_values errors }
      ... on FloatField { spec { title name editable reference required causer } value possible_values errors }
      ... on DecimalField { spec { title name editable reference required causer } value possible_values errors }
    }
  }
`

export const STATUSES = gql`
  query contract_status {
    contract_status {
      id code title order action
    }
  }
`

export const STATS = gql`
  query contract_stats($filter: ContractFilter) {
    contract_stats(filter: $filter) {
      group count
    }
  }
`

export const LOGS = gql`
  query contract_logs($filter: ContractLogFilter, $sort: SortDirection, $offset: Int, $limit: Int) {
    contract_logs(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
      items {
        contractId contractOwnerId contractTitle companyId companyTitle userId userName prevStatus newStatus insertedAt
      }
      total_count
    }
  }
`

export const LOGS_STATS = gql`
  query contract_logs_stats($filter: ContractLogFilter) {
    contract_logs_stats(filter: $filter) {
      group count
    }
  }
`

export const IMPORT_CONTRACT_POSITIONS = gql`
  mutation import_contract_positions($contract_id: Int!, $file: String!, $name: String!){
    import_contract_positions(contract_id: $contract_id, file: $file, name: $name) {
      positions { id position_id title anno amount unit_id price vat currency_id delivery_within_days vendor_code }
      errors { field, errors }
    }
  }
`

export const POSITIONS = gql`
  query contract_position($filter: ContractPositionFilter, $offset: Int, $limit: Int) {
    contract_position(filter: $filter, offset: $offset, limit: $limit) {
      positions { id position_id title anno amount unit_id price vat currency_id delivery_within_days vendor_code }
      totalCount
      actions { create read update delete }
    }
  }
`

export const APPEND_WINNER_POSITIONS = gql`
  mutation append_tender_winner_positions($contract_id: Int!, $tender_id: Int!, $company_id: Int!) {
    append_tender_winner_positions(contract_id: $contract_id, tender_id: $tender_id, company_id: $company_id) {
      positions { id position_id title anno amount unit_id price vat currency_id delivery_within_days vendor_code }
      errors { field, errors }
    }
  }
`

export const REMOVE_POSITIONS = gql`
  mutation remove_contract_positions($contract_id: Int!, $positions: [Int]) {
    remove_contract_positions(contract_id: $contract_id, positions: $positions) {
      removed
    }
  }
`

export const CREATE_POSITION = gql`
  mutation create_contract_position($contract_id: Int!, $input: ContractPositionInput!) {
    create_contract_position(contract_id: $contract_id, input: $input) {
      position { id position_id title anno amount unit_id price vat currency_id delivery_within_days vendor_code }
      errors { field, errors }
    }
  }
`

export const UPDATE_POSITION = gql`
  mutation update_contract_position($position_id: Int!, $input: ContractPositionInput!) {
    update_contract_position(position_id: $position_id, input: $input) {
      position { id position_id title anno amount unit_id price vat currency_id delivery_within_days vendor_code }
      errors { field, errors }
    }
  }
`

export const DOCUMENT_TEMPLATES = gql`
  query document_templates($filter: DocumentTemplateFilter $offset: Int! $limit: Int!){
    documentTemplates(filter: $filter, limit: $limit, offset: $offset){
      data {
        id title fields { key value }
      }
      totalCount
    }
  }
`

export const LOAD_DOCUMENT_TEMPLATE = gql`
  query loadDocumentTemplate($templateId: Int!){
    loadDocumentTemplate(templateId: $templateId){
      name data
    }
  }
`

export const CREATE_DOCUMENT_TEMPLATE = gql`
  mutation createDocumentTemplate($file: String!, $title: String!){
    createDocumentTemplate(file: $file, title: $title){
      id, title
    }
  }
`

export const UPDATE_DOCUMENT_TEMPLATE = gql`
  mutation updateDocumentTemplate($templateId: Int!, $title: String, $fields: [DocumentFieldInput]){
    updateDocumentTemplate(templateId: $templateId, title: $title, fields: $fields){
      id title fields { key value }
    }
  }
`

export const RENDER_DOCUMENT = gql`
  mutation renderDocument($documentId: Int!, $fields: [DocumentFieldInput]) {
    renderDocument(documentId: $documentId, fields: $fields) {
      name data
  }
}
`

export const CREATE_DOCUMENT = gql`
  mutation createDocument($contractId: Int!, $templateId: Int!, $title: String, $fields: [DocumentFieldInput]) {
    createDocument(contractId: $contractId, templateId: $templateId, title: $title, fields: $fields) {
      id title templateId contractId fields { key value }
  }
}
`

export const UPDATE_DOCUMENT = gql`
  mutation updateDocument($documentId: Int!, $title: String, $fields: [DocumentFieldInput]) {
    updateDocument(documentId: $documentId, title: $title, fields: $fields) {
      id title templateId contractId fields { key value }
  }
}
`

export const DOCUMENTS = gql`
  query getDocuments($contractId: Int, $templateId: Int, $limit: Int!, $offset: Int!) {
    documents(filter: {contractId: $contractId, templateId: $templateId}, limit: $limit, offset: $offset) {
      data {
        id
        title
        templateId
        contractId
        fields {
          key
          value
        }
      }
      totalCount
    }
  }
`

export const DELETE_DOCUMENTS = gql`
  mutation deleteDocuments($contract_id: Int!, $id: [Int]!){
    deleteDocuments(contract_id: $contract_id, id: $id){
      deletedCount
    }
  }
`

export const COMPANY_INFO = gql`
  query getCompanyInfo($id: Int) {
    companyInfo(id: $id) {
      ogrn rs ks bik bank inn kpp title fullTitle address director
    }
  }
`

export const USER_INFO = gql`
  query getUserInfo($id: Int) {
    userInfo(id: $id) {
      id name email
    }
  }
`
